import * as Sentry from '@sentry/browser'

export default function reportError(error: Error) {
  Sentry.captureException(error)
}
